module.exports = __webpack_public_path__ + "f344b773fc0c3f2be659115384d69aca.png";